import React from 'react';
import { useDispatch } from 'react-redux';

// Import actions
import { fetchVodCover, fetchVodPoster } from 'store/actions';

// Import components
import Image from 'components/utilities/images/Image';
import InfoTitleCollapse from 'components/utilities/info/InfoTitleCollapse';

// Import translation
import { useTranslation } from 'react-i18next';

// Import helpers
import {
	IMAGE_SIZE_INFO,
	PRODUCT_IMAGES_REQUIREMENTS
} from 'components/helpers/info_helpers/info_texts';

const EpisodesImages = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	return (
		<>
			<InfoTitleCollapse
				title={IMAGE_SIZE_INFO}
				requirements={PRODUCT_IMAGES_REQUIREMENTS}
			/>
			<Image
				title={t('common:images.cover')}
				fetchResourcesAction={(id) => fetchVodCover(id)(dispatch)}
				collectionType="cover"
				mediaType="vod"
				storePathSelector="vod"
				productSubtype="episode"
			/>
			<Image
				title={t('common:images.poster')}
				fetchResourcesAction={(id) => fetchVodPoster(id)(dispatch)}
				collectionType="poster"
				mediaType="vod"
				storePathSelector="vod"
				productSubtype="episode"
			/>
		</>
	);
};

export default EpisodesImages;
